import { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import { AuthUrlContext } from "../../context/createContext";
import { BrandLogo } from "./index";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import ListOutlinedIcon from "@mui/icons-material/ListOutlined";
import InsertChartOutlinedIcon from "@mui/icons-material/InsertChartOutlined";
import FactoryOutlinedIcon from "@mui/icons-material/FactoryOutlined";
import LocalMallOutlinedIcon from "@mui/icons-material/LocalMallOutlined";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";
import DynamicFormOutlinedIcon from "@mui/icons-material/DynamicFormOutlined";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import TransferWithinAStationOutlinedIcon from "@mui/icons-material/TransferWithinAStationOutlined";
import RemoveShoppingCartOutlinedIcon from "@mui/icons-material/RemoveShoppingCartOutlined";
import GroupAddOutlinedIcon from "@mui/icons-material/GroupAddOutlined";
import ReceiptOutlinedIcon from "@mui/icons-material/ReceiptOutlined";
import EventNoteOutlinedIcon from "@mui/icons-material/EventNoteOutlined";
import ProductionQuantityLimitsOutlinedIcon from "@mui/icons-material/ProductionQuantityLimitsOutlined";
import RequestPageOutlinedIcon from "@mui/icons-material/RequestPageOutlined";
// import RestaurantMenuOutlinedIcon from "@mui/icons-material/RestaurantMenuOutlined";
// import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import { 
    BookOnlineOutlined, 
    CorporateFareOutlined, 
    DescriptionOutlined, 
    InfoOutlined, 
    MonetizationOnOutlined, 
    MoneyOffOutlined, 
    MoveToInbox, 
    PaymentOutlined, 
    ProductionQuantityLimitsOutlined, 
    SecurityOutlined, 
    Shop2Outlined, 
    SummarizeOutlined, 
    SupervisedUserCircleOutlined, 
    TransferWithinAStationOutlined 
} from "@mui/icons-material";

export const SideBarNew = () => {
    const [activeOption, setActiveOption] = useState("");
    const [selectedLink, setSelectedLink] = useState("Home");
    const [thirdCell, setThirdCell] = useState("");
    const [activeReports, setActiveReports] = useState("")
    let navigate = useNavigate();
    const { userRights } = useContext(AuthUrlContext);
    const { urlList, userRole } = userRights;
    const [fourthCell, setFourthCell] = useState("")
    const body = document.getElementsByTagName("body");
    let isSuperAdmin = userRole === "ROLE_SUPER_ADMIN";

    const updateClasses = (value) => {
        const body = document.getElementsByTagName("body");
        const sideBarDiv = document.getElementById("left-sidebar");
        if (selectedLink === value) {
            if (body[0].classList.contains("body-nav-link")) {
                body[0].classList.remove("body-nav-link");
            } else {
                body[0].classList.add("body-nav-link");
            }
        } else {
            if (!body[0].classList.contains("body-nav-link")) {
                body[0].classList.add("body-nav-link");
            }
            setSelectedLink(value);
        }

        if (sideBarDiv.classList.contains("body-sub-menu")) {
            sideBarDiv.classList.remove("body-sub-menu");
            body[0].classList.remove("third-sub-menu")
        }
        setThirdCell("")
    };

    const handleThirdMenuCell = (name) => {
        const sideBarDiv = document.getElementById("left-sidebar");
        const body = document.getElementsByTagName("body");
        if (sideBarDiv) {
            if (thirdCell === name) {
                if (sideBarDiv.classList.contains("body-sub-menu")) {
                    body[0].classList.remove("third-sub-menu")
                    sideBarDiv.classList.remove("body-sub-menu");
                } else {
                    sideBarDiv.classList.add("body-sub-menu");
                    body[0].classList.add("third-sub-menu")

                }
            } else {
                if (!sideBarDiv.classList.contains("body-sub-menu")) {
                    sideBarDiv.classList.add("body-sub-menu");
                    body[0].classList.add("third-sub-menu")
                }
            }
        }
        setThirdCell(name);
    };

    const addClassInLastMenu = () => {
        const thirdMenu = document.querySelectorAll('.third-menu');
        if (thirdMenu) {
            thirdMenu.forEach((item) => {
                item.classList.add('active-last');
            })
        }
        const bodyElement = document.getElementsByTagName('body');
        if (bodyElement) {
            bodyElement[0].classList.add('body-last-menu')
        }
    }

    const removeClassInLastMenu = () => {
        const thirdMenu = document.querySelectorAll('.third-menu');
        if (thirdMenu) {
            thirdMenu.forEach((item) => {
                item.classList.remove('active-last');
            })
        }
        const bodyElement = document.getElementsByTagName('body')
        if (bodyElement) {
            bodyElement[0].classList.remove('body-last-menu')
        }
    }
    const content = document.getElementById("main-content")
    content?.addEventListener('click', function () {
        if (body[0].classList.contains("third-sub-menu")) {
            body[0].classList.remove("third-sub-menu")
        }
    })


    return (
        <>
            <div id="left-sidebar" className="sidebar mini_sidebar_on border-0 ">
                <div
                    className="slimScrollDiv"
                    style={{
                        position: "relative",

                        width: "auto",
                        height: "calc(100vh - 0px)",
                        borderRight: "1px solid #e1e8ed",
                        boxShadow: "0 5px 10px 0px rgba(23, 25, 28, 0.2)",
                    }}
                >
                    <div
                        className="sidebar-scroll"
                        style={{
                            width: "auto",
                            background: "#fff",
                            height: "calc(100vh - 65px)",
                        }}
                    >
                        <BrandLogo />
                        <div id="left-sidebar-nav" className="sidebarNew-nav">
                            <ul className="metismenu">
                                <li
                                    className={`navLi ${selectedLink === "Dashboard" ? "active" : ""}`}
                                // onClick={() => $(this).addClass("active")}
                                >
                                    <Link to="/" onClick={() => updateClasses("Home")}>
                                        <span className="svg-nav">
                                            <HomeOutlinedIcon />
                                        </span>
                                        <span className="nav-text-content">Dashboard</span>
                                    </Link>
                                </li>
                                <li className={`${selectedLink === "Inventory" ? "active" : ""}`}>
                                    <Link className="custom-nav-link has-arrow cursor-pointer d-flex align-items-center" onClick={() => updateClasses("Inventory")} aria-expanded="false">
                                        <span className="svg-nav">
                                            <ListOutlinedIcon />
                                        </span>
                                        <span className="nav-text-content">Inventory</span>
                                    </Link>
                                    <ul aria-expanded="false" className="collapse custom-collapse" style={{ height: "0px" }}>
                                        <li>
                                            <div className="subMenuItem">
                                                {(isSuperAdmin || urlList.has("/items/getAllRecords")) && (
                                                    <Link to="/items" className=" ember-view p-0 d-flex align-items-center" id="ember170">
                                                        <span style={{ marginRight: 5 }}>
                                                            <CategoryOutlinedIcon />
                                                        </span>
                                                        <span>Items</span>
                                                    </Link>
                                                )}
                                            </div>
                                        </li>
                                        <li>
                                            <div className="subMenuItem">
                                                {(isSuperAdmin || urlList.has("/itemPriceList/getAllRecords")) && (
                                                    <Link to="/pricelists" className="  ember-view p-0 d-flex align-items-center" id="ember170">
                                                        <span style={{ marginRight: 5 }}>
                                                            <DynamicFormOutlinedIcon />
                                                        </span>
                                                        <span>Price Lists</span>
                                                    </Link>
                                                )}
                                            </div>
                                        </li>
                                        <li>
                                            <div className="subMenuItem">
                                                {false && (
                                                    <Link to="/ItemsPriceList" className="  ember-view p-0 d-flex align-items-center" id="ember170">
                                                        <span style={{ marginRight: 5 }}>
                                                            <DynamicFormOutlinedIcon />
                                                        </span>
                                                        <span>Items Price Lists</span>
                                                    </Link>
                                                )}
                                            </div>
                                        </li>
                                        <li>
                                            <div className="subMenuItem">
                                                {(isSuperAdmin || urlList.has("/issuance/getAllRecords")) && (
                                                    <Link to="/issueitems" className=" ember-view p-0 d-flex align-items-center" id="ember170">
                                                        <span style={{ marginRight: 5 }}>
                                                            <CategoryOutlinedIcon />
                                                        </span>
                                                        <span>Issue Items</span>
                                                    </Link>
                                                )}
                                            </div>
                                        </li>
                                        <li>
                                            <div className="subMenuItem">
                                                {(isSuperAdmin || urlList.has("/stockClosing/warehouseList/{warehouse}")) && (
                                                    <Link to="/stockClosing/list" className="ember-view p-0 d-flex align-items-center" id="ember170">
                                                        <span style={{ marginRight: 5 }}>
                                                            <Inventory2OutlinedIcon />
                                                        </span>
                                                        <span>Stock Closing</span>
                                                    </Link>
                                                )}
                                            </div>
                                        </li>
                                        <li>
                                            <div className="subMenuItem">
                                                {(isSuperAdmin || urlList.has("/wastage/warehouseList/{uuid}")) && (
                                                    <Link to="/wastage/list" className="ember-view p-0 d-flex align-items-center" id="ember170">
                                                        <span style={{ marginRight: 5 }}>
                                                            <RemoveShoppingCartOutlinedIcon />
                                                        </span>
                                                        <span>Wastage</span>
                                                    </Link>
                                                )}
                                            </div>
                                        </li>
                                        <li>
                                            <div className="subMenuItem">
                                                {(true) && (
                                                    <Link to="/salestarget" className="ember-view p-0 d-flex align-items-center" id="ember170">
                                                        <span style={{ marginRight: 5 }}>
                                                            <CategoryOutlinedIcon />
                                                        </span>
                                                        <span>Sales Target List</span>
                                                    </Link>
                                                )}

                                            </div>
                                            {/* <div className="subMenuItem">
                                                {(true) && (
                                                    <Link to="/fgitems/new" className="ember-view p-0 d-flex align-items-center" id="ember170">
                                                        <span style={{ marginRight: 5 }}>
                                                            <CategoryOutlinedIcon />
                                                        </span>
                                                        <span>FG Items New</span>
                                                    </Link>
                                                )}
                                            </div> */}

                                        </li>
                                    </ul>
                                </li>
                                <li className={`${selectedLink === "StockTransfer" ? "active" : ""}`}>
                                    <Link className="custom-nav-link has-arrow cursor-pointer d-flex align-items-center" onClick={() => updateClasses("StockTransfer")} aria-expanded="false">
                                        <span className="svg-nav">
                                            <TransferWithinAStationOutlinedIcon />
                                        </span>
                                        <span className="nav-text-content">Stock Transfer</span>
                                    </Link>
                                    <ul aria-expanded="false" className="collapse custom-collapse" style={{ height: "0px" }}>
                                        <li>
                                            <div className="subMenuItem">
                                                {(isSuperAdmin || urlList.has("/stockTransfer/getAllRecords")) && (
                                                    <Link to="/stockTransfer/list" className="ember-view p-0 d-flex align-items-center" id="ember170">
                                                        <span style={{ marginRight: 5 }}>
                                                            <TransferWithinAStationOutlined />
                                                        </span>
                                                        <span>Stock Transfer</span>
                                                    </Link>
                                                )}
                                            </div>
                                        </li>
                                        <li>
                                            <div className="subMenuItem">
                                                {(isSuperAdmin || urlList.has("/stockTransfer/approved/{uuid}")) && (
                                                    <Link to="/stockTransferReceived/list" className="ember-view p-0 d-flex align-items-center" id="ember170">
                                                        <span style={{ marginRight: 5 }}>
                                                            <MoveToInbox />
                                                        </span>
                                                        <span> Received</span>
                                                    </Link>
                                                )}
                                            </div>
                                        </li>
                                        <li>
                                            <div className="subMenuItem">
                                                {(isSuperAdmin || urlList.has("/storeTransfer/getAllRecords")) && (
                                                    <Link to="/storeTransfer/list" className="ember-view p-0 d-flex align-items-center" id="ember170">
                                                        <span style={{ marginRight: 5 }}>
                                                            <TransferWithinAStationOutlined />
                                                        </span>
                                                        <span>Store to Store</span>
                                                    </Link>
                                                )}
                                            </div>
                                        </li>
                                    </ul>
                                </li>
                                <li className={`${selectedLink === "Sales" ? "active" : ""}`}>
                                    <Link className="custom-nav-link has-arrow cursor-pointer d-flex align-items-center" onClick={() => updateClasses("Sales")} aria-expanded="false">
                                        <span className="svg-nav">
                                            <ShoppingCartOutlinedIcon />
                                        </span>
                                        <span className="nav-text-content">Sales</span>
                                    </Link>
                                    <ul aria-expanded="false" className="collapse custom-collapse" style={{ height: "0px" }}>
                                        <li className="navLi">
                                            <div className="subMenuItem">
                                                {(isSuperAdmin || urlList.has("/customer/getAllRecords")) && (
                                                    <Link to="/contacts" className="ember-view p-0 d-flex align-items-center" id="ember170">
                                                        <span style={{ marginRight: 5 }}>
                                                            <GroupAddOutlinedIcon />
                                                        </span>
                                                        <span>Customers</span>
                                                    </Link>
                                                )}
                                            </div>
                                        </li>
                                        <li className="navLi">
                                            <div className="subMenuItem">
                                                {(isSuperAdmin || urlList.has("/salesOrder/getAllRecords")) && (
                                                    <Link to="/salesorders" className="ember-view p-0 d-flex align-items-center" id="ember170">
                                                        <span style={{ marginRight: 5 }}>
                                                            <ShoppingCartOutlinedIcon />
                                                        </span>
                                                        <span>Sales Orders</span>
                                                    </Link>
                                                )}
                                            </div>
                                        </li>

                                        <li className="navLi">
                                            <div className="subMenuItem">
                                                {(isSuperAdmin || urlList.has("/invoice/getAllRecords")) && (
                                                    <Link to="/invoices" className="ember-view p-0 d-flex align-items-center" id="ember170">
                                                        <span style={{ marginRight: 5 }}>
                                                            <ReceiptOutlinedIcon />
                                                        </span>
                                                        <span>Invoices</span>
                                                    </Link>
                                                )}
                                            </div>
                                        </li>
                                        <li className="navLi">
                                            {(isSuperAdmin || urlList.has("/creditNote/")) && (
                                                <div className="subMenuItem">
                                                    <Link to="/CreditNoteView/" className="ember-view p-0 d-flex align-items-center" id="ember170">
                                                        <span style={{ marginRight: 5 }}>
                                                            <EventNoteOutlinedIcon />
                                                        </span>
                                                        <span>Credit Note</span>
                                                    </Link>
                                                    {/* <AddIcon /> */}
                                                </div>
                                            )}
                                        </li>
                                        <li className="navLi">
                                            {(isSuperAdmin || urlList.has("/getRecordsByWarehouseId")) && (
                                                <div className="subMenuItem">
                                                    <Link to="/PickList" className="ember-view p-0 d-flex align-items-center" id="ember170">
                                                        <span style={{ marginRight: 5 }}>
                                                            <EventNoteOutlinedIcon />
                                                        </span>
                                                        <span>Pick List</span>
                                                    </Link>
                                                    {/* <AddIcon /> */}
                                                </div>
                                            )}
                                        </li>
                                    </ul>
                                </li>
                                <li className={`${selectedLink === "Purchase" ? "active" : ""}`}>
                                    <Link className=" custom-nav-link has-arrow cursor-pointer d-flex align-items-center" onClick={() => updateClasses("Purchase")} aria-expanded="false">
                                        <span className="svg-nav">
                                            <LocalMallOutlinedIcon />
                                        </span>
                                        <span className="nav-text-content">Purchase</span>
                                    </Link>
                                    <ul aria-expanded="false" className="collapse custom-collapse" style={{ height: "0px" }}>
                                        <li>
                                            <div className="subMenuItem">
                                                {(isSuperAdmin || urlList.has("/vendor/getAllRecords")) && (
                                                    <Link to="/vendors" className="ember-view p-0 d-flex align-items-center" id="ember170">
                                                        <span style={{ marginRight: 5 }}>
                                                            <EventNoteOutlinedIcon />
                                                        </span>
                                                        <span>Vendors</span>
                                                    </Link>
                                                )}
                                            </div>
                                        </li>
                                        <li>
                                            <div className="subMenuItem">
                                                {(isSuperAdmin || urlList.has("/purchaseOrder/getAllRecords")) && (
                                                    <Link to="/purchase/" className="ember-view p-0 d-flex align-items-center" id="ember170">
                                                        <span style={{ marginRight: 5 }}>
                                                            <ShoppingCartOutlinedIcon />
                                                        </span>
                                                        <span>Purchase</span>
                                                    </Link>
                                                )}
                                            </div>
                                        </li>
                                        <li>
                                            <div className="subMenuItem">
                                                {(isSuperAdmin || urlList.has("/bill/getAllRecords")) && (
                                                    <Link to={"/bills"} className="ember-view p-0 d-flex align-items-center" id="ember170">
                                                        <span style={{ marginRight: 5 }}>
                                                            <EventNoteOutlinedIcon />
                                                        </span>
                                                        <span>GRN</span>
                                                    </Link>
                                                )}
                                            </div>
                                        </li>
                                        <li className="navLi">
                                            {(isSuperAdmin || urlList.has("/debitNote/getAllRecords")) && (
                                                <div className="subMenuItem">
                                                    <Link to="/DebitNoteView/" className="ember-view p-0 d-flex align-items-center" id="ember170">
                                                        <span style={{ marginRight: 5 }}>
                                                            <EventNoteOutlinedIcon />
                                                        </span>
                                                        <span>Debit Note</span>
                                                    </Link>
                                                </div>
                                            )}
                                        </li>
                                    </ul>
                                </li>
                                {/* production */}
                                <li className={`${selectedLink === "Production" ? "active" : ""}`}>
                                    <Link className="custom-nav-link has-arrow cursor-pointer d-flex align-items-center" onClick={() => updateClasses("Production")} aria-expanded="false">
                                        <span className="svg-nav">
                                            <FactoryOutlinedIcon />
                                        </span>
                                        <span className="nav-text-content">Production</span>
                                    </Link>
                                    <ul aria-expanded="false" className="collapse custom-collapse" style={{ height: "0px" }}>
                                        <li>
                                            <div className="subMenuItem">
                                                {(isSuperAdmin || urlList.has("/recipe/getAllRecords")) && (
                                                    <Link to="/recipe" className="ember-view p-0 d-flex align-items-center" id="ember170">
                                                        <span style={{ marginRight: 5 }}>
                                                            <EventNoteOutlinedIcon />
                                                        </span>
                                                        <span>Recipe</span>
                                                    </Link>
                                                )}
                                            </div>
                                        </li>

                                        <li>
                                            <div className="subMenuItem">
                                                {(isSuperAdmin || urlList.has("/batches/getAllRecords")) && (
                                                    <Link to="/batches" className="ember-view p-0 d-flex align-items-center" id="ember170">
                                                        <span style={{ marginRight: 5 }}>
                                                            <ProductionQuantityLimitsOutlinedIcon />
                                                        </span>
                                                        <span>Today's Production</span>
                                                    </Link>
                                                )}
                                            </div>
                                        </li>

                                        <li>
                                            <div className="subMenuItem">
                                                {(isSuperAdmin || urlList.has("/requisition/getAllRecords")) && (
                                                    <Link to="/requisition" className="ember-view p-0 d-flex align-items-center" id="ember170">
                                                        <span style={{ marginRight: 5 }}>
                                                            <RequestPageOutlinedIcon />
                                                        </span>
                                                        <span>Requisition</span>
                                                    </Link>
                                                )}
                                            </div>
                                        </li>
                                    </ul>
                                </li>
                                {/* RRM Recipe
                                <li className={`${selectedLink === "RRM Recipe" ? "active" : ""}`}>
                                    <Link className="custom-nav-link has-arrow cursor-pointer d-flex align-items-center" onClick={() => updateClasses("RRM Recipe")} aria-expanded="false">
                                        <span className="svg-nav">
                                            <RestaurantMenuOutlinedIcon />
                                        </span>
                                        <span className="nav-text-content">RRM Recipe</span>
                                    </Link>
                                    <ul aria-expanded="false" className="collapse custom-collapse" style={{ height: "0px" }}>
                                        <li>
                                            <div className="subMenuItem">
                                                <Link to="/rrm/cuisine" className="ember-view p-0 d-flex align-items-center">
                                                    <span style={{ marginRight: 5 }}>
                                                        <MenuBookOutlinedIcon />
                                                    </span>
                                                    <span>Cuisine</span>
                                                </Link>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="subMenuItem">
                                                <Link to="/rrm/ingredient" className="ember-view p-0 d-flex align-items-center">
                                                    <span style={{ marginRight: 5 }}>
                                                        <CategoryOutlinedIcon />
                                                    </span>
                                                    <span>Ingredient</span>
                                                </Link>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="subMenuItem">
                                                <Link to="/rrm/item-recipe" className="ember-view p-0 d-flex align-items-center">
                                                    <span style={{ marginRight: 5 }}>
                                                        <EventNoteOutlinedIcon />
                                                    </span>
                                                    <span>Item Recipe</span>
                                                </Link>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="subMenuItem">
                                                <Link to="/rrm/condiment-recipe" className="ember-view p-0 d-flex align-items-center">
                                                    <span style={{ marginRight: 5 }}>
                                                        <EventNoteOutlinedIcon />
                                                    </span>
                                                    <span>Condiment Recipe</span>
                                                </Link> 
                                            </div   >
                                        </li>
                                        <li>
                                            <div className="subMenuItem">
                                                <Link to="/rrm/customization-recipe" className="ember-view p-0 d-flex align-items-center">
                                                    <span style={{ marginRight: 5 }}>
                                                        <EventNoteOutlinedIcon />
                                                    </span>
                                                    <span>Customization Recipe</span>
                                                </Link>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="subMenuItem">
                                                <Link to="/rrm/restaurant-employee" className="ember-view p-0 d-flex align-items-center">
                                                    <span style={{ marginRight: 5 }}>
                                                        <SupervisedUserCircleOutlined />
                                                    </span>
                                                    <span>Restaurant Employee</span>
                                                </Link>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="subMenuItem">
                                                <Link to="/rrm/otp" className="ember-view p-0 d-flex align-items-center">
                                                    <span style={{ marginRight: 5 }}>
                                                        <SecurityOutlined />
                                                    </span>
                                                    <span>OTP</span>
                                                </Link>
                                            </div>
                                        </li>
                                    </ul>
                                </li> */}
                                <li className={`${selectedLink === "Reports" ? "active" : ""}`}>
                                    <Link className="custom-nav-link has-arrow cursor-pointer d-flex align-items-center" onClick={() => updateClasses("Reports")} aria-expanded="false">
                                        <span className="svg-nav">
                                            <InsertChartOutlinedIcon />
                                        </span>
                                        <span className="nav-text-content">Reports</span>
                                    </Link>
                                    <ul aria-expanded="false" className="collapse custom-collapse" style={{ height: "0px" }}>
                                        <li className={`${thirdCell === "Sales" ? "active" : ""} submenu-li`} >
                                            <div className="subMenuItem">
                                                <div className="w-100">
                                                    <Link onClick={() => handleThirdMenuCell("Sales")} className="custom-nav-nav-link submenu-nav-link has-arrow ember-view p-0 d-flex align-items-center">
                                                        <span className="svg-nav">
                                                            <EventNoteOutlinedIcon />
                                                        </span>
                                                        <span className="sub-text-content">Sales</span>
                                                    </Link>
                                                </div>
                                                <ul
                                                    onMouseEnter={addClassInLastMenu}
                                                    onMouseLeave={removeClassInLastMenu}
                                                    style={{ width: fourthCell === "active" ? "45px" : "" }}
                                                    className="custom-collapse third-menu"
                                                // onClick={()=>setFourthCell("active")}
                                                >
                                                    {/* {(isSuperAdmin || urlList.has("report/salesOrder/getSalesOrderBySalesPersonId")) && (
                                                        <li>
                                                            <div className="subMenuItem">
                                                                <Link to="/reports/SalesByCustomer" className=" custom-nav-nav-nav-link ember-view p-0 d-flex align-items-center">
                                                                    <span style={{ marginRight: "5px" }}>
                                                                        <SummarizeOutlined />
                                                                    </span>
                                                                    <span className="third-sub-content">Sales By Customer</span>
                                                                </Link>
                                                            </div>
                                                        </li>
                                                    )} */}
                                                    {(isSuperAdmin || urlList.has("report/invoice/getInvoiceDetail")) && (
                                                        <li>
                                                            <div className="subMenuItem">
                                                                <Link to="/reports/SalesByInvoice" className="custom-nav-nav-nav-link ember-view p-0 d-flex align-items-center">
                                                                    <span style={{ marginRight: "5px" }}>
                                                                        <SummarizeOutlined />
                                                                    </span>
                                                                    <span className="third-sub-content">Sales by Invoice</span>
                                                                </Link>
                                                            </div>
                                                        </li>
                                                    )}
                                                    {(isSuperAdmin || urlList.has("report/salesOrder/getSalesOrderBySalesPersonId")) && (
                                                        <li>
                                                            <div className="subMenuItem">
                                                                <Link to="/reports/SalesBySalesPerson" className="custom-nav-nav-nav-link ember-view p-0 d-flex align-items-center">
                                                                    <span style={{ marginRight: "5px" }}>
                                                                        <SummarizeOutlined />
                                                                    </span>
                                                                    <span className="third-sub-content">Sales by Sales Person</span>
                                                                </Link>
                                                            </div>
                                                        </li>
                                                    )}
                                                    {(isSuperAdmin || urlList.has("report/invoice/getItemsSoldByHsnId")) && (
                                                        <li>
                                                            <div className="subMenuItem">
                                                                <Link to="/reports/SalesByItems" className="custom-nav-nav-nav-link ember-view p-0 d-flex align-items-center">
                                                                    <span style={{ marginRight: "5px" }}>
                                                                        <SummarizeOutlined />
                                                                    </span>
                                                                    <span className="third-sub-content">Sales By Item</span>
                                                                </Link>
                                                            </div>
                                                        </li>
                                                    )}
                                                    {(isSuperAdmin || urlList.has("report/invoice/salesMarginReport")) && (
                                                        <li>
                                                            <div className="subMenuItem">
                                                                <Link to="/reports/SalesMarginReport" className="custom-nav-nav-nav-link ember-view p-0 d-flex align-items-center">
                                                                    <span style={{ marginRight: "5px" }}>
                                                                        <SummarizeOutlined />
                                                                    </span>
                                                                    <span className="third-sub-content">Sales Margin Report</span>
                                                                </Link>
                                                            </div>
                                                        </li>
                                                    )}
                                                    {/* {(isSuperAdmin || urlList.has("report/itemPriceList/itemPriceListReport")) && (
                                                        <li>
                                                            <div className="subMenuItem">
                                                                <Link to="/reports/SalesReports" className="custom-nav-nav-nav-link ember-view p-0 d-flex align-items-center">
                                                                    <span style={{ marginRight: "5px" }}>
                                                                        <SummarizeOutlined />
                                                                    </span>
                                                                    <span className="third-sub-content">Sales Reports</span>
                                                                </Link>
                                                            </div>
                                                        </li>
                                                    )} */}
                                                    {/* {(isSuperAdmin || urlList.has("report/pendingSalesOrderByCustomer")) && (
                                                        <li>
                                                            <div className="subMenuItem">
                                                                <Link to="/reports/PendingSalesOrderByCustomer" className="custom-nav-nav-nav-link ember-view p-0 d-flex align-items-center">
                                                                    <span style={{ marginRight: "5px" }}>
                                                                        <SummarizeOutlined />
                                                                    </span>
                                                                    <span className="third-sub-content">Pending Sales Order by Customer</span>
                                                                </Link>
                                                            </div>
                                                        </li>
                                                    )} */}
                                                    {(isSuperAdmin || urlList.has("report/SalesByCreditNotes")) && (
                                                        <li>
                                                            <div className="subMenuItem">
                                                                <Link to="/reports/SalesByCreditNotes" className="custom-nav-nav-nav-link ember-view p-0 d-flex align-items-center">
                                                                    <span style={{ marginRight: "5px" }}>
                                                                        <SummarizeOutlined />
                                                                    </span>
                                                                    <span className="third-sub-content">Sales By Credit Notes</span>
                                                                </Link>
                                                            </div>
                                                        </li>
                                                    )}
                                                    {/* {(true) && (
                                                        <li>
                                                            <div className="subMenuItem">
                                                                <Link to="/reports/SalesCustom" className="custom-nav-nav-nav-link ember-view p-0 d-flex align-items-center">
                                                                    <span style={{ marginRight: "5px" }}>
                                                                        <SummarizeOutlined />
                                                                    </span>
                                                                    <span className="third-sub-content">Sales Custom</span>
                                                                </Link>
                                                            </div>
                                                        </li>
                                                    )} */}
                                                    {(true) && (
                                                        <li>
                                                            <div className="subMenuItem">
                                                                <Link to="/reports/monthlySalesByCustomer" className="custom-nav-nav-nav-link ember-view p-0 d-flex align-items-center">
                                                                    <span style={{ marginRight: "5px" }}>
                                                                        <SummarizeOutlined />
                                                                    </span>
                                                                    <span className="third-sub-content">Monthly Sales By Customer</span>
                                                                </Link>
                                                            </div>
                                                        </li>
                                                    )}
                                                    {(true) && (
                                                        <li>
                                                            <div className="subMenuItem">
                                                                <Link to="/reports/monthlySoldItems" className="custom-nav-nav-nav-link ember-view p-0 d-flex align-items-center">
                                                                    <span style={{ marginRight: "5px" }}>
                                                                        <SummarizeOutlined />
                                                                    </span>
                                                                    <span className="third-sub-content">Monthly Sold Items</span>
                                                                </Link>
                                                            </div>
                                                        </li>
                                                    )}
                                                </ul>
                                            </div>
                                        </li>
                                        <li className={`${thirdCell === "Purchase" ? "active" : ""} submenu-li`} >
                                            <div className="subMenuItem">
                                                <div>
                                                    <Link onClick={() => handleThirdMenuCell("Purchase")} className="custom-nav-nav-link submenu-nav-link has-arrow ember-view p-0 d-flex align-items-center">
                                                        <span className="svg-nav">
                                                            <LocalMallOutlinedIcon />
                                                        </span>
                                                        <span className="sub-text-content">Purchase</span>
                                                    </Link>
                                                </div>
                                                <ul onMouseEnter={addClassInLastMenu}
                                                    onMouseLeave={removeClassInLastMenu} aria-expanded="false" className="collapse custom-collapse third-menu" style={{ height: "0px" }}>
                                                    {(isSuperAdmin || urlList.has("report/purchaseOrder/getPurchaseOrderByVendorId")) && (
                                                        <li>
                                                            <div className="subMenuItem">
                                                                <Link to="/reports/PurchaseByVender" className="ember-view p-0 d-flex align-items-center">
                                                                    <span style={{ marginRight: "5px" }}>
                                                                        <Shop2Outlined />
                                                                    </span>
                                                                    <span className="third-sub-content">Purchase by Vendor</span>
                                                                </Link>
                                                            </div>
                                                        </li>
                                                    )}
                                                    {(isSuperAdmin || urlList.has("report/invoice/getItemsPurchaseReport")) && (
                                                        <li>
                                                            <div className="subMenuItem">
                                                                <Link to="/reports/PurchaseByItem" className="ember-view p-0 d-flex align-items-center">
                                                                    <span style={{ marginRight: "5px" }}>
                                                                        <Shop2Outlined />
                                                                    </span>
                                                                    <span className="third-sub-content">Purchase by Item</span>
                                                                </Link>
                                                            </div>
                                                        </li>
                                                    )}
                                                    {(isSuperAdmin || urlList.has("report/purchaseOrder/purchaseProjectionReport")) && (
                                                        <li>
                                                            <div className="subMenuItem">
                                                                <Link to="/reports/PurchaseReports" className="ember-view p-0 d-flex align-items-center">
                                                                    <span style={{ marginRight: "5px" }}>
                                                                        <Shop2Outlined />
                                                                    </span>
                                                                    <span className="third-sub-content">Purchase reports</span>
                                                                </Link>
                                                            </div>
                                                        </li>
                                                    )}
                                                    {(isSuperAdmin || urlList.has("report/purchaseOrder/grnReport")) && (
                                                        <li>
                                                            <div className="subMenuItem">
                                                                <Link to="/reports/GRNReport" className="ember-view p-0 d-flex align-items-center">
                                                                    <span className="svg-nav">
                                                                        <Shop2Outlined />
                                                                    </span>
                                                                    <span className="third-sub-content">GRN Report</span>
                                                                </Link>
                                                            </div>
                                                        </li>
                                                    )}
                                                    {(isSuperAdmin || urlList.has("report/pendingPurchaseOrderByVendor")) && (
                                                        <li>
                                                            <div className="subMenuItem">
                                                                <Link to="/reports/PendingPurchaseOrderByVender" className="ember-view p-0 d-flex align-items-center">
                                                                    <span style={{ marginRight: "5px" }}>
                                                                        <Shop2Outlined />
                                                                    </span>
                                                                    <span className="third-sub-content">Pending Purchase Order by Vendor</span>
                                                                </Link>
                                                            </div>
                                                        </li>
                                                    )}
                                                </ul>
                                            </div>
                                        </li>
                                        <li className={`${thirdCell === "Others" ? "active" : ""} submenu-li`} >
                                            <div className="subMenuItem">
                                                <div>
                                                    <Link onClick={() => handleThirdMenuCell("Others")} className=" custom-nav-nav-link submenu-nav-link has-arrow ember-view p-0 d-flex align-items-center">
                                                        <span className="svg-nav">
                                                            <EventNoteOutlinedIcon />
                                                        </span>
                                                        <span className="sub-text-content">Others</span>
                                                    </Link>
                                                </div>
                                                <ul onMouseEnter={addClassInLastMenu}
                                                    onMouseLeave={removeClassInLastMenu} aria-expanded="false" className="collapse custom-collapse third-menu" style={{ height: "0px" }}>
                                                    {(isSuperAdmin || urlList.has("report/warehouseItems/getBelowOrderLevelItemReport")) && (
                                                        <li>
                                                            <div className="subMenuItem">
                                                                <Link to="/reports/BelowReorderPoint" className="ember-view p-0 d-flex align-items-center">
                                                                    <span style={{ marginRight: "5px" }}>
                                                                        <InfoOutlined />
                                                                    </span>
                                                                    <span className="third-sub-content">Below Reorder Point</span>
                                                                </Link>
                                                            </div>
                                                        </li>
                                                    )}
                                                    {(isSuperAdmin || urlList.has("report/warehouseItems/getBelowOrderLimitSetPointReport")) && (
                                                        <li>
                                                            <div className="subMenuItem">
                                                                <Link to="/reports/BelowOrderLimitSetPoint" className="ember-view p-0 d-flex align-items-center">
                                                                    <span style={{ marginRight: "5px" }}>
                                                                        <InfoOutlined />
                                                                    </span>
                                                                    <span className="third-sub-content">Below Order Limit Set Point</span>
                                                                </Link>
                                                            </div>
                                                        </li>
                                                    )}
                                                    {(isSuperAdmin || urlList.has("report/warehouseItems/getInventorySummary")) && (
                                                        <li>
                                                            <div className="subMenuItem">
                                                                <Link to="/reports/InventorySummary" className="ember-view p-0 d-flex align-items-center">
                                                                    <span style={{ marginRight: "5px" }}>
                                                                        <InfoOutlined />
                                                                    </span>
                                                                    <span className="third-sub-content">Inventory Summary</span>
                                                                </Link>
                                                            </div>
                                                        </li>
                                                    )}
                                                    {(isSuperAdmin || urlList.has("report/purchaseOrder/issueReport")) && (
                                                        <li>
                                                            <div className="subMenuItem">
                                                                <Link to="/reports/IssueReports" className="ember-view p-0 d-flex align-items-center">
                                                                    <span style={{ marginRight: "5px" }}>
                                                                        <InfoOutlined />
                                                                    </span>
                                                                    <span className="third-sub-content">Issue Report</span>
                                                                </Link>
                                                            </div>
                                                        </li>
                                                    )}
                                                    {(isSuperAdmin || urlList.has("report/requisitonReport")) && (
                                                        <li>
                                                            <div className="subMenuItem">
                                                                <Link to="/reports/RequisitionReport" className="ember-view p-0 d-flex align-items-center">
                                                                    <span style={{ marginRight: "5px" }}>
                                                                        <InfoOutlined />
                                                                    </span>
                                                                    <span className="third-sub-content">Requisition Report</span>
                                                                </Link>
                                                            </div>
                                                        </li>
                                                    )}
                                                    {(isSuperAdmin || urlList.has("report/purchaseOrder/stockReport")) && (
                                                        <li>
                                                            <div className="subMenuItem">
                                                                <Link to="/reports/StockReport" className="ember-view p-0 d-flex align-items-center">
                                                                    <span style={{ marginRight: "5px" }}>
                                                                        <InfoOutlined />
                                                                    </span>
                                                                    <span className="third-sub-content">Stock Report</span>
                                                                </Link>
                                                            </div>
                                                        </li>
                                                    )}
                                                    {(isSuperAdmin || urlList.has("report/purchaseOrder/stockReport")) && (
                                                        <li>
                                                            <div className="subMenuItem">
                                                                <Link to="/reports/StockHistory" className="ember-view p-0 d-flex align-items-center">
                                                                    <span style={{ marginRight: "5px" }}>
                                                                        <InfoOutlined />
                                                                    </span>
                                                                    <span className="third-sub-content">Stock History</span>
                                                                </Link>
                                                            </div>
                                                        </li>
                                                    )}
                                                    {(isSuperAdmin || urlList.has("report/purchaseOrder/stockReport")) && (
                                                        <li>
                                                            <div className="subMenuItem">
                                                                <Link to="/reports/StockTransferReports" className="ember-view p-0 d-flex align-items-center">
                                                                    <span style={{ marginRight: "5px" }}>
                                                                        <InfoOutlined />
                                                                    </span>
                                                                    <span className="third-sub-content">Stock Transfer Report</span>
                                                                </Link>
                                                            </div>
                                                        </li>
                                                    )}
                                                    {(isSuperAdmin || urlList.has("report/stockTransferByItemReport") || urlList.has("report/purchaseOrder/stockReport")) && (
                                                        <li>
                                                            <div className="subMenuItem">
                                                                <Link to="/reports/StockTransferByItem" className="ember-view p-0 d-flex align-items-center">
                                                                    <span style={{ marginRight: "5px" }}>
                                                                        <InfoOutlined />
                                                                    </span>
                                                                    <span className="third-sub-content">Stock Transfer By Item</span>
                                                                </Link>
                                                            </div>
                                                        </li>
                                                    )}
                                                    {(isSuperAdmin || urlList.has("report/nonMovingItemReport") || urlList.has("report/purchaseOrder/stockReport")) && (
                                                        <li>
                                                            <div className="subMenuItem">
                                                                <Link to="/reports/NonMovingItems" className="ember-view p-0 d-flex align-items-center">
                                                                    <span style={{ marginRight: "5px" }}>
                                                                        <InfoOutlined />
                                                                    </span>
                                                                    <span className="third-sub-content">Non Moving Items</span>
                                                                </Link>
                                                            </div>
                                                        </li>
                                                    )}
                                                    {(isSuperAdmin || urlList.has("report/wipReport")) && (
                                                        <li>
                                                            <div style={{ marginRight: "5px" }}>
                                                                <Link to="/reports/WipReport" className="ember-view p-0 d-flex align-items-center">
                                                                    <span className="svg-nav">
                                                                        <InfoOutlined />
                                                                    </span>
                                                                    <span className="third-sub-content">Wip Report</span>
                                                                </Link>
                                                            </div>
                                                        </li>
                                                    )}
                                                    {(isSuperAdmin || urlList.has("report/deficitReport")) && (
                                                        <li>
                                                            <div className="subMenuItem">
                                                                <Link to="/reports/OthersVsSoh" className="ember-view p-0 d-flex align-items-center">
                                                                    <span style={{ marginRight: "5px" }}>
                                                                        <InfoOutlined />
                                                                    </span>
                                                                    <span className="third-sub-content">PO vs Stock In Hand</span>
                                                                </Link>
                                                            </div>
                                                        </li>
                                                    )}
                                                    {(isSuperAdmin || urlList.has("report/purchaseOrder/stockReport")) && (
                                                        <li>
                                                            <div className="subMenuItem">
                                                                <Link to="/reports/palleteOccupacy" className="ember-view p-0 d-flex align-items-center">
                                                                    <span style={{ marginRight: "5px" }}>
                                                                        <InfoOutlined />
                                                                    </span>
                                                                    <span className="third-sub-content">Pallete Occupacy</span>
                                                                </Link>
                                                            </div>
                                                        </li>
                                                    )}
                                                    {(isSuperAdmin || urlList.has("report/purchaseOrder/stockReport")) && (
                                                        <li>
                                                            <div className="subMenuItem">
                                                                <Link to="/reports/customerFssai" className="ember-view p-0 d-flex align-items-center">
                                                                    <span style={{ marginRight: "5px" }}>
                                                                        <InfoOutlined />
                                                                    </span>
                                                                    <span className="third-sub-content">Customer Fssai Report</span>
                                                                </Link>
                                                            </div>
                                                        </li>
                                                    )}
                                                    {(isSuperAdmin || urlList.has("report/purchaseOrder/stockReport")) && (
                                                        <li>
                                                            <div className="subMenuItem">
                                                                <Link to="/reports/customerCategoryDiscount" className="ember-view p-0 d-flex align-items-center">
                                                                    <span style={{ marginRight: "5px" }}>
                                                                        <InfoOutlined />
                                                                    </span>
                                                                    <span className="third-sub-content">Customer Category Discount</span>
                                                                </Link>
                                                            </div>
                                                        </li>
                                                    )}
                                                    {(true) && (
                                                        <li>
                                                            <div className="subMenuItem">
                                                                <Link to="/reports/OrdersVsDispatch" className="custom-nav-nav-nav-link ember-view p-0 d-flex align-items-center">
                                                                    <span style={{ marginRight: "5px" }}>
                                                                        <SummarizeOutlined />
                                                                    </span>
                                                                    <span className="third-sub-content">Variance Report</span>
                                                                </Link>
                                                            </div>
                                                        </li>
                                                    )}
                                                    {/* {(true) && (
                                                        <li>
                                                            <div className="subMenuItem">
                                                            <Link to="/reports/FgItemsReport" className="ember-view p-0 d-flex align-items-center" id="ember170">
                                                        <span style={{ marginRight: 5 }}>
                                                            <CategoryOutlinedIcon />
                                                        </span>
                                                        <span>FG Items</span>
                                                    </Link>
                                                            </div>
                                                        </li>
                                                    )} */}
                                                </ul>
                                            </div>
                                        </li>
                                        <li className={`${thirdCell === "Production" ? "active" : ""} submenu-li`}>
                                            <div className="subMenuItem">
                                                <div>
                                                    <Link onClick={() => handleThirdMenuCell("Production")} className="custom-nav-nav-link submenu-nav-link has-arrow ember-view p-0 d-flex align-items-center">
                                                        <span className="svg-nav">
                                                            <FactoryOutlinedIcon />
                                                        </span>
                                                        <span className="sub-text-content">Production</span>
                                                    </Link>
                                                </div>
                                                <ul onMouseEnter={addClassInLastMenu}
                                                    onMouseLeave={removeClassInLastMenu} aria-expanded="false" className="collapse custom-collapse third-menu" style={{ height: "0px" }}>
                                                    {(isSuperAdmin || urlList.has("report/batches/getBatchesDetail")) && (
                                                        <li>
                                                            <div className="subMenuItem">
                                                                <Link to="/reports/ProductionSummary" className="ember-view p-0 d-flex align-items-center">
                                                                    <span style={{ marginRight: "5px" }}>
                                                                        <ProductionQuantityLimitsOutlinedIcon />
                                                                    </span>
                                                                    <span className="third-sub-content">Production Summary</span>
                                                                </Link>
                                                            </div>
                                                        </li>
                                                    )}
                                                    {(isSuperAdmin || urlList.has("reports/consumptionVsCurrentStock")) && (
                                                        <li>
                                                            <div className="subMenuItem">
                                                                <Link to="/reports/ConsumptionVsCurrentStock" className="ember-view p-0 d-flex align-items-center">
                                                                    <span style={{ marginRight: "5px" }}>
                                                                        <ProductionQuantityLimitsOutlinedIcon />
                                                                    </span>
                                                                    <span className="third-sub-content">Consumption Vs Current Stock</span>
                                                                </Link>
                                                            </div>
                                                        </li>
                                                    )}
                                                    {(isSuperAdmin || urlList.has("reports/hsnReport")) && (
                                                        <li>
                                                            <div className="subMenuItem">
                                                                <Link to="/reports/HsnReport" className="ember-view p-0 d-flex align-items-center">
                                                                    <span style={{ marginRight: "5px" }}>
                                                                        <ProductionQuantityLimitsOutlinedIcon />
                                                                    </span>
                                                                    <span className="third-sub-content">Hsn Report</span>
                                                                </Link>
                                                            </div>
                                                        </li>
                                                    )}
                                                    {(isSuperAdmin || urlList.has("reports/hsnReport")) && (
                                                        <li>
                                                            <div className="subMenuItem">
                                                                <Link to="/reports/CrHsnReport" className="ember-view p-0 d-flex align-items-center">
                                                                    <span style={{ marginRight: "5px" }}>
                                                                        <ProductionQuantityLimitsOutlinedIcon />
                                                                    </span>
                                                                    <span className="third-sub-content">Credit Hsn Report</span>
                                                                </Link>
                                                            </div>
                                                        </li>
                                                    )}
                                                </ul>
                                            </div>
                                        </li>
                                    </ul>
                                </li>
                                {isSuperAdmin && (
                                    <li className={`${selectedLink === "Setting" ? "active" : ""}`}>
                                        <Link className="custom-nav-link has-arrow cursor-pointer d-flex align-items-center" onClick={() => updateClasses("Setting")} aria-expanded="false">
                                            <span className="svg-nav">
                                                <SettingsOutlinedIcon />
                                            </span>
                                            <span className="nav-text-content">Settings</span>
                                        </Link>
                                        <ul aria-expanded="false" className="collapse custom-collapse" style={{ height: "0px" }}>
                                            <li className={`${thirdCell === "Organization" ? "active" : ""} submenu-li`} >
                                                <div className="subMenuItem">
                                                    <div className="w-100">
                                                        <Link onClick={() => handleThirdMenuCell("Organization")} className="custom-nav-nav-link  submenu-nav-link has-arrow ember-view p-0 d-flex align-items-center">
                                                            <span className="svg-nav">
                                                                <FactoryOutlinedIcon />
                                                            </span>
                                                            <span className="sub-text-content">Organization</span>
                                                        </Link>
                                                    </div>
                                                    <ul onMouseEnter={addClassInLastMenu}
                                                        onMouseLeave={removeClassInLastMenu}
                                                        className="custom-collapse third-menu">
                                                        <li>
                                                            <div className="subMenuItem">
                                                                <Link to={"/settings/preferences/Organization"} id="ember699" className="ember-view nav-link p-0 d-flex align-items-center">
                                                                    <span style={{ marginRight: "5px" }}>
                                                                        <CorporateFareOutlined />
                                                                    </span>
                                                                    <span className="third-sub-content">Organization</span>
                                                                </Link>
                                                            </div>
                                                        </li>

                                                        <li>
                                                            <div className="subMenuItem">
                                                                <Link to={"/settings/Preferences/Warehouses"} id="ember699" className="ember-view nav-link p-0 d-flex align-items-center">
                                                                    <span style={{ marginRight: "5px" }}>
                                                                        <CorporateFareOutlined />
                                                                    </span>
                                                                    <span className="third-sub-content">Warehouses</span>
                                                                </Link>
                                                            </div>
                                                        </li>

                                                        <li>
                                                            <div className="subMenuItem">
                                                                <Link to={"/settings/preferences/store"} id="ember699" className="ember-view nav-link p-0 d-flex align-items-center">
                                                                    <span style={{ marginRight: "5px" }}>
                                                                        <CorporateFareOutlined />
                                                                    </span>
                                                                    <span className="third-sub-content">Store</span>
                                                                </Link>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div className="subMenuItem">
                                                                <Link to={"/settings/preferences/rack"} id="ember699" className="ember-view nav-link p-0 d-flex align-items-center">
                                                                    <span style={{ marginRight: "5px" }}>
                                                                        <CorporateFareOutlined />
                                                                    </span>
                                                                    <span className="third-sub-content">Rack</span>
                                                                </Link>
                                                            </div>
                                                        </li>

                                                        <li>
                                                            <div className="subMenuItem">
                                                                <Link to={"/settings/preferences/cell"} id="ember699" className="ember-view nav-link p-0 d-flex align-items-center">
                                                                    <span style={{ marginRight: "5px" }}>
                                                                        <CorporateFareOutlined />
                                                                    </span>
                                                                    <span className="third-sub-content">Cell/Floor</span>
                                                                </Link>
                                                            </div>
                                                        </li>

                                                        <li>
                                                            <div className="subMenuItem">
                                                                <Link to={"/settings/preferences/pallet"} id="ember699" className="ember-view nav-link p-0 d-flex align-items-center">
                                                                    <span style={{ marginRight: "5px" }}>
                                                                        <CorporateFareOutlined />
                                                                    </span>
                                                                    <span className="third-sub-content">Pallet</span>
                                                                </Link>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div className="subMenuItem">
                                                                <Link to={"/settings/preferences/DepartmentList"} id="ember699" className="ember-view nav-link p-0 d-flex align-items-center">
                                                                    <span style={{ marginRight: "5px" }}>
                                                                        <CorporateFareOutlined />
                                                                    </span>
                                                                    <span className="third-sub-content"> Department</span>
                                                                </Link>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </li>
                                            <li className={`${thirdCell === "Categories" ? "active" : ""} submenu-li`} >
                                                <div className="subMenuItem">
                                                    <div>
                                                        <Link onClick={() => handleThirdMenuCell("Categories")} className="custom-nav-nav-link  submenu-nav-link has-arrow ember-view p-0 d-flex align-items-center">
                                                            <span className="svg-nav">
                                                                <CategoryOutlinedIcon />
                                                            </span>
                                                            <span className="sub-text-content">Categories</span>
                                                        </Link>
                                                    </div>
                                                    <ul aria-expanded="false" onMouseEnter={addClassInLastMenu}
                                                        onMouseLeave={removeClassInLastMenu}
                                                        style={{ width: fourthCell === "active" ? "45px" : "" }}
                                                        className="custom-collapse third-menu">
                                                        <li>
                                                            <div className="subMenuItem">
                                                                <Link to={"/settings/preferences/sub-categories"} id="ember699" className="ember-view nav-link p-0 d-flex align-items-center">
                                                                    <span style={{ marginRight: "5px" }}>
                                                                        <CategoryOutlinedIcon />
                                                                    </span>
                                                                    <span className="third-sub-content">Item Sub Categories</span>
                                                                </Link>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div className="subMenuItem">
                                                                <Link to={"/settings/preferences/categories"} id="ember699" className="ember-view nav-link p-0 d-flex align-items-center">
                                                                    <span style={{ marginRight: "5px" }}>
                                                                        <CategoryOutlinedIcon />
                                                                    </span>
                                                                    <span className="third-sub-content">Item Categories</span>
                                                                </Link>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div className="subMenuItem">
                                                                <Link to={"/settings/preferences/vendor-categories"} id="ember699" className="ember-view nav-link p-0 d-flex align-items-center">
                                                                    <span style={{ marginRight: "5px" }}>
                                                                        <CategoryOutlinedIcon />
                                                                    </span>
                                                                    <span className="third-sub-content">Vendor Categories</span>
                                                                </Link>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div className="subMenuItem">
                                                                <Link to={"/settings/preferences/customer-categories"} id="ember699" className="ember-view nav-link p-0 d-flex align-items-center">
                                                                    <span style={{ marginRight: "5px" }}>
                                                                        <CategoryOutlinedIcon />
                                                                    </span>
                                                                    <span className="third-sub-content"> Customer Categories</span>
                                                                </Link>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </li>
                                            <li className={`${thirdCell === "UserRoles" ? "active" : ""} submenu-li`} >
                                                <div className="subMenuItem">
                                                    <div>
                                                        <Link onClick={() => handleThirdMenuCell("UserRoles")} className=" custom-nav-nav-link submenu-nav-link has-arrow ember-view p-0 d-flex align-items-center">
                                                            <span className="svg-nav">
                                                                <SupervisedUserCircleOutlined />
                                                            </span>
                                                            <span className="sub-text-content">Users And Roles</span>
                                                        </Link>
                                                    </div>
                                                    <ul aria-expanded="false" onMouseEnter={addClassInLastMenu}
                                                        onMouseLeave={removeClassInLastMenu}
                                                        className="custom-collapse third-menu">
                                                        <li>
                                                            <div className="subMenuItem">
                                                                <Link to={"/settings/preferences/DefaultUrlList"} id="ember699" className="ember-view nav-link p-0 d-flex align-items-center">
                                                                    <span style={{ marginRight: "5px" }}>
                                                                        <SecurityOutlined />
                                                                    </span>
                                                                    <span className="third-sub-content">Default Roles</span>
                                                                </Link>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div className="subMenuItem">
                                                                <Link to={"/settings/Preferences/UserAndRoles"} id="ember699" className="ember-view nav-link p-0 d-flex align-items-center">
                                                                    <span style={{ marginRight: "5px" }}>
                                                                        <SecurityOutlined />
                                                                    </span>
                                                                    <span className="third-sub-content">User Roles</span>
                                                                </Link>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div className="subMenuItem">
                                                                <Link to={"/settings/preferences/DeliveryPersonList"} id="ember699" className="ember-view nav-link p-0 d-flex align-items-center">
                                                                    <span style={{ marginRight: "5px" }}>
                                                                        <SecurityOutlined />
                                                                    </span>
                                                                    <span className="third-sub-content">Delivery Person</span>
                                                                </Link>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div className="subMenuItem">
                                                                <Link to={"/settings/preferences/salesperson"} id="ember699" className="ember-view nav-link p-0 d-flex align-items-center">
                                                                    <span style={{ marginRight: "5px" }}>
                                                                        <SecurityOutlined />
                                                                    </span>
                                                                    <span className="third-sub-content">Salesperson</span>
                                                                </Link>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </li>
                                            <li className={`${thirdCell === "Taxes" ? "active" : ""} submenu-li`} >
                                                <div className="subMenuItem">
                                                    <div>
                                                        <Link onClick={() => handleThirdMenuCell("Taxes")} className="custom-nav-nav-link  submenu-nav-link has-arrow ember-view p-0 d-flex align-items-center">
                                                            <span className="svg-nav">
                                                                <MoneyOffOutlined />
                                                            </span>
                                                            <span className="sub-text-content">Taxes</span>
                                                        </Link>
                                                    </div>
                                                    <ul aria-expanded="false" onMouseEnter={addClassInLastMenu}
                                                        onMouseLeave={removeClassInLastMenu}
                                                        className="custom-collapse third-menu">
                                                        <li>
                                                            <div className="subMenuItem">
                                                                <Link to={"/settings/preferences/HSN"} id="ember699" className="ember-view nav-link p-0 d-flex align-items-center">
                                                                    <span style={{ marginRight: "5px" }}>
                                                                        <MonetizationOnOutlined />
                                                                    </span>
                                                                    <span className="third-sub-content">HSN</span>
                                                                </Link>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div className="subMenuItem">
                                                                <Link to={"/settings/preferences/quality-parameter"} id="ember699" className="ember-view nav-link p-0 d-flex align-items-center">
                                                                    <span style={{ marginRight: "5px" }}>
                                                                        <MonetizationOnOutlined />
                                                                    </span>
                                                                    <span className="third-sub-content">Quality Parameter</span>
                                                                </Link>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div className="subMenuItem">
                                                                <Link to={"/settings/Preferences/TaxList"} id="ember699" className="ember-view nav-link p-0 d-flex align-items-center">
                                                                    <span style={{ marginRight: "5px" }}>
                                                                        <MonetizationOnOutlined />
                                                                    </span>
                                                                    <span className="third-sub-content">Taxes</span>
                                                                </Link>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div className="subMenuItem">
                                                                <Link to={"/settings/preferences/TaxExempt"} id="ember699" className="ember-view nav-link p-0 d-flex align-items-center">
                                                                    <span style={{ marginRight: "5px" }}>
                                                                        <MonetizationOnOutlined />
                                                                    </span>
                                                                    <span className="third-sub-content">Tax Exemption</span>
                                                                </Link>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div className="subMenuItem">
                                                                <Link to={"/settings/preferences/TDS"} id="ember699" className="ember-view nav-link p-0 d-flex align-items-center">
                                                                    <span style={{ marginRight: "5px" }}>
                                                                        <MonetizationOnOutlined />
                                                                    </span>
                                                                    <span className="third-sub-content">TDS</span>
                                                                </Link>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div className="subMenuItem">
                                                                <Link to={"/settings/preferences/tcs-rate"} id="ember699" className="ember-view nav-link p-0 d-flex align-items-center">
                                                                    <span style={{ marginRight: "5px" }}>
                                                                        <MonetizationOnOutlined />
                                                                    </span>
                                                                    <span className="third-sub-content">TCS</span>
                                                                </Link>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </li>
                                            <li className={`${thirdCell === "Terms" ? "active" : ""} submenu-li`} >
                                                <div className="subMenuItem">
                                                    <div>
                                                        <Link onClick={() => handleThirdMenuCell("Terms")} className="custom-nav-nav-link  submenu-nav-link has-arrow ember-view p-0 d-flex align-items-center">
                                                            <span className="svg-nav">
                                                                <DescriptionOutlined />
                                                            </span>
                                                            <span className="sub-text-content">Terms</span>
                                                        </Link>
                                                    </div>
                                                    <ul aria-expanded="false" onMouseEnter={addClassInLastMenu}
                                                        onMouseLeave={removeClassInLastMenu}
                                                        style={{ width: fourthCell === "active" ? "45px" : "" }}
                                                        className="custom-collapse third-menu">
                                                        <li>
                                                            <div className="subMenuItem">
                                                                <Link to={"/settings/preferences/TermsConditionList"} id="ember699" className="ember-view nav-link p-0 d-flex align-items-center">
                                                                    <span style={{ marginRight: "5px" }}>
                                                                        <BookOnlineOutlined />
                                                                    </span>
                                                                    <span className="third-sub-content">  Terms Condition</span>
                                                                </Link>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div className="subMenuItem">
                                                                <Link to={"/settings/preferences/PaymentTerms"} id="ember699" className="ember-view nav-link p-0 d-flex align-items-center">
                                                                    <span style={{ marginRight: "5px" }}>
                                                                        <PaymentOutlined />
                                                                    </span>
                                                                    <span className="third-sub-content"> Payment Terms</span>
                                                                </Link>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div className="subMenuItem">
                                                                <Link to={"/settings/preferences/UnitList"} id="ember699" className="ember-view nav-link p-0 d-flex align-items-center">
                                                                    <span style={{ marginRight: "5px" }}>
                                                                        <ProductionQuantityLimitsOutlined />
                                                                    </span>
                                                                    <span className="third-sub-content"> Units</span>
                                                                </Link>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </li>
                                        </ul>
                                    </li>
                                )}
                                {/* <li className={`${selectedLink === "Reports" ? "active" : ""}`}>
                                    <Link to="/reports" className="custom-nav-link ember-view p-0" id="ember171">
                                        <span className=" cursor-pointer d-flex align-items-center" onClick={() => updateClasses("Reports")} aria-expanded="false">
                                            <span className="svg-nav">
                                                <InsertChartOutlinedIcon />
                                            </span>
                                            <span className="nav-text-content">Reports</span>
                                        </span>
                                    </Link>
                                </li> */}
                                {/* {isSuperAdmin && (
                                    <div style={{ border: 0, paddingLeft: 0 }}>
                                        <Link to="/settings/preferences">
                                            <Link to="/settings/preferences" className="custom-nav-link cursor-pointer d-flex align-items-center" aria-expanded="false">
                                                <span className="svg-nav">
                                                    <SettingsOutlinedIcon />
                                                </span>
                                                <span className="ml-2 nav-text-content">Settings</span>
                                            </Link>
                                            <ul aria-expanded="false" className="collapse" style={{ height: "0px" }}>
                                                {userRole === "ROLE_SUPER_ADMIN" && <li className={userRole === "ROLE_SUPER_ADMIN" ? "d-block" : "d-none"}></li>}
                                            </ul>
                                        </Link>
                                    </div>
                                )} */}
                            </ul>
                        </div>
                    </div>
                    <div
                        className="slimScrollBar"
                        style={{
                            background: "rgb(28, 34, 44)",
                            width: "2px",
                            position: "absolute",
                            top: "0px",
                            opacity: "0.4",
                            display: "block",
                            borderRadius: "3px",
                            zIndex: "99",
                            right: "1px",
                            height: "255.162px",
                        }}
                    ></div>
                    <div
                        className="slimScrollRail"
                        style={{
                            width: "2px",
                            height: "100%",
                            position: "absolute",
                            top: "0px",
                            display: "none",
                            borderRadius: "7px",
                            background: "rgb(51, 51, 51)",
                            opacity: "0.2",
                            zIndex: "90",
                            right: "1px",
                        }}
                    ></div>
                </div>
            </div>
        </>
    );
};

export default SideBarNew;
